import { render } from "./MessageIn.vue?vue&type=template&id=fdbcac72"
import script from "./MessageIn.vue?vue&type=script&lang=ts"
export * from "./MessageIn.vue?vue&type=script&lang=ts"
script.render = render

export default script